/**
 * File Upload
 * @todo make this a class
 */

function fileupload() {
  return {
    restrict: "A",
    scope: {
      theFile: "=",
      theName: "=",
    },
    link: function (scope, element, attrs) {
      element.bind("change", function () {
        var $fakeSelect = $(element).parents(".custom-upload").find("input.placeholder");
        $fakeSelect.val(event.target.files[0].name);

        var files = element.prop("files");
        var filename = files[0].name;

        scope.$apply(function () {
          var reader = new FileReader();

          reader.onload = function (event) {
            scope.$evalAsync(function () {
              scope.theFile = event.target.result;
              scope.theName = filename;
            });
          };
          reader.readAsDataURL(event.target.files[0]);
        });
      });
    },
  };
}

export default angular.module("fileupload", []).directive("fileupload", fileupload).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/fileupload.directive.js
 **/